<template>
  <div class="monitor-equipment"></div>
</template>

<script type="text/ecmascript-6">
import MonitoringDevice from './MonitoringDevice.js'
export default MonitoringDevice
</script>

<style lang="scss">
@import "MonitoringDevice";
</style>



// WEBPACK FOOTER //
// src/views/assets/monitoringDevice/MonitoringDevice.vue